module.exports = __webpack_public_path__ + "static/media/Follower_Button-23.7729c40c.png";